import background from 'assets/img/background-login.jpg'
import logoNormal from 'assets/img/logo-normal.svg'
import { useAuth } from 'contexts/AuthContext'
import { useUser } from 'contexts/UserContext'
import LoginForm from 'forms/Login/LoginForm'
import useFetch from 'hooks/useFetch'
import { useEffect, useState } from 'react'
import { useLocation } from 'wouter'

export default function Login() {
  const { setUser } = useUser()
  const { setToken } = useAuth()
  const [, setLocation] = useLocation()

  // useFetch(): hook personalizado para realizar solicitudes GET, POST, PUT, DELETE
  const [requestedLogin, requestLogin] = useFetch()

  // useState()
  const [error, setError] = useState(null)

  // CRUD: POST
  const handleSubmit = async (values) => {
    const apiCallParams = {
      url: 'auth/login',
      method: 'POST',
      body: values,
      messageKo: '¡Usuario y/o contraseña incorrectos!'
    }
    await requestLogin(apiCallParams)
  }

  // Escuchar POST
  useEffect(() => {
    if (requestedLogin.data) {
      setLocation('/')
      setError(null)
      setUser(requestedLogin?.data?.user)
      setToken(requestedLogin?.data?.token)
    }
  }, [requestedLogin.data])

  // Mostrar mensaje API: POST / PUT (notificación de éxito o error)
  useEffect(() => {
    if (requestedLogin.isCalled && requestedLogin.error) {
      setError('¡Usuario y/o contraseña incorrectos!')
    }
  }, [requestedLogin.loading])

  return (
    <>
      <div className="flex items-center w-screen h-dvh">
        <div
          className="fixed z-10 block w-full h-full bg-top brightness-50"
          style={{
            background: `url(${background})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
          }}
        />

        <div className="relative z-50 flex items-center justify-center w-full">
          <div className="w-11/12 max-w-lg overflow-hidden bg-white rounded-lg shadow-lg sm:w-full dark:lg:bg-gray-800">
            <div className="flex justify-center w-full p-0">
              <div className="w-full h-24 overflow-hidden border-4 border-white rounded-t-lg bg-base">
                <img
                  className="pb-1 mx-auto -mt-4 size-32"
                  src={logoNormal}
                  alt="Claim Sphere"
                />
              </div>
            </div>

            <LoginForm
              error={error}
              requestedLogin={requestedLogin}
              handleSubmit={handleSubmit}
            />
          </div>
        </div>
      </div>
    </>
  )
}
